const DARK_URL = 'https://api.darksky.net/forecast/'

const MAP_URL = 'https://maps.googleapis.com/maps/api/geocode/json'

export { DARK_URL, MAP_URL }